import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Page } from '../models/page-wrapper.model';

export interface documentCategory {
  id?: number | string;
  code?: string;
  name?: string;
  description?: string;
}
export interface intendedUse {
  id?: number | string;
  code?: string;
  name?: string;
  description?: string;
}


@Injectable({ providedIn: 'root' })
export class ListOfValuesService {
  private readonly apiUrl = `${environment.restApiUrl}`;

  constructor(private http: HttpClient) {}


  // Fetch intent use values by type: GET /api/listofvalues/{type}
  getAllIntentUse( params?: any): Observable<Page<intendedUse>> {
    return this.http.get<Page<intendedUse>>(`${this.apiUrl}masterdata/intended-uses`, { params });
  }
  
  
  getAllDocumentCategory( params?: any): Observable<Page<documentCategory>> {
    return this.http.get<Page<documentCategory>>(`${this.apiUrl}masterdata/document-categories`, { params });
  }

}